import React, { useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { ApiUrl, Headers } from '../services/ApiUrl'
import { useUserStore } from '../stores/UserStore'
import { Container, Row, Col, Card, ListGroup, Button, Form, Alert, Spinner, Modal } from 'react-bootstrap';
import axios from 'axios'
import { useForm } from "react-hook-form"
import HeroVotar from './VotarHero';
import ContactFormModal from './ContactForm';
import { useSystemOptionsStore } from '../stores/useOptions';


const PanelVotante = ({ userVotante }) => {
    const [showInput, setShowInput] = useState(false);
    const [datosDNI, setDatosDNI] = useState([])
    const [consultandoAPI, setConsultandoAPI] = useState(false)
    const [mensajeError, setMensajeError] = useState([])
    const [dniPadron, setDniPadron] = useState([])
    const [mostrarConfirmacion, setMostrarConfirmacion] = useState(false)
    const [mostrarEnviandoMail, setMostrarEnviandoMail] = useState(false)
    const [mostrarForm, setMostrarForm] = useState(false)
    const [disabledButton, setDisabledButton] = useState(false)
    const [idVotante, setIdVotante] = useState(0)
    const [codigoConfirmacion, setCodigoConfirmacion] = useState('')
    const [errorCodigoConfirm, setErrorCodigoConfirm] = useState([])
    const [showHelpModal, setShowHelpModal] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [showContactModal, setShowContactModal] = useState(false);
    const { systemOptions } = useSystemOptionsStore();

    const userGlobal = useUserStore((state) => state.userGlobal)
    const updateUser = useUserStore((state) => state.updateUser)

    const {
        register,
        handleSubmit,
        clearErrors,
        formState: { errors },
    } = useForm()

    const handleContactClick = () => {
        if (systemOptions.whatsapp) {
            // Formatear número para URL de WhatsApp y abrir en nueva pestaña
            const whatsappNumber = systemOptions.whatsapp.replace(/\D/g, '');
            const message = encodeURIComponent('Hola, no recibí mi código de confirmación para votar');
            window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
        } else {
            setShowContactModal(true);
        }
    };

    const onSubmit = (data) => {
        setDisabledButton(true)
        setConsultandoAPI(true)
        setMensajeError("")
        setMostrarConfirmacion(false)
        let url = ApiUrl + 'registrarvoto'
        axios.post(url, data, { headers: Headers })
            .then(response => {
                //console.log(response)           
                if (response.data.error === true) {
                    // error de que ya votó, para poder reclamar
                    if (response.data.yavoto === true) {
                        setDisabledButton(false)
                        setDniPadron(
                            {
                                existe: true,
                                mensaje: response.data.mensaje
                            }
                        )
                    }
                    // error de que no figura en el padrón
                    if (response.data.existe === false) {
                        setDisabledButton(false)
                        setMensajeError(
                            {
                                existe: true,
                                mensaje: response.data.mensaje
                            }
                        )
                    }

                } else {
                    // si todo está ok, tiene que enviar el mail
                    if (response.data.enviarcodigo === true) {
                        setIdVotante(response.data.id_votante)
                        setMostrarConfirmacion(true)
                        // pruebo sin enviar los mails
                        enviarMailCodigo(response.data.id_votante)
                    }
                }
            }).catch(error => {
            })
            .finally(function () {
                setConsultandoAPI(false)
            });
    }

    const limpiarerrores = () => {
        setDniPadron([])
        clearErrors()
    }

    const enviarMailCodigo = (id_votante) => {
        // envio mail del id_votante
        let url = ApiUrl + 'enviarmailcodigo'
        let datos = {
            id_votante: id_votante
        }
        axios.post(url, datos, { headers: Headers })
            .then(response => {
                //console.log(response)           
            }).catch(error => {
            })
            .finally(function () {

            });
        //alert('El votante es el ' + id_votante)
    }

    const capturarValorCodigo = (e) => {
        setCodigoConfirmacion(e.target.value)
        setErrorCodigoConfirm([])
    }

    const comprobarCodigoVotante = () => {
        if (codigoConfirmacion.length !== 6) {
            setErrorCodigoConfirm({
                error: true,
                mensaje: "El código de confirmación tiene que tener 6 dígitos"
            })
            return
        }
        // envia id_votante y codigo y la API responde OK o no
        let url = ApiUrl + 'validarcodigo'
        let datos = {
            id_votante: idVotante,
            codigo_confirm: codigoConfirmacion
        }
        let newUser = []
        axios.post(url, datos, { headers: Headers })
            .then(response => {
                //console.log(response)     

                if (response.data.error === true) {
                    setErrorCodigoConfirm({
                        error: true,
                        mensaje: "El código de confirmación no es válido. Intentá nuevamente"
                    })
                }
                if (response.data.error === false) {
                    // inicio sesión en zustand. 
                    newUser = {
                        error: false,
                        login: true,
                        id_user: idVotante,
                        isVoted: false,
                        codigo_confirm: response.data.codigo_confirm,
                        name_user: response.data.nombre_apellido_votante,
                        dni: response.data.dni,
                        errorMsg: ""
                    }
                    updateUser(newUser)
                    // Y redirijo a todas las propuestas
                    // ACÁ VA LA REDIRECCIÓN
                }
            }).catch(error => {

                newUser({
                    error: true,
                    errorMsg: 'Error de conexión a la API',
                    errorMsgOrig: error
                })
                updateUser(newUser)
            })
            .finally(function () {

            });
    }

    useEffect(() => {
        const img = new Image();
        img.src = "https://www.trenquelauquen.gov.ar/wordpress/wp-content/uploads/numero_tramite_dni-1.jpeg";
        img.onload = () => {
            setImageLoaded(true);
        };
    }, []);

    return (

        <>


            {!userGlobal.login &&
                <>

                    <HeroVotar />




                    <Container id='votar'>
                        <Row>
                            <Col>


                                <p style={{ marginTop: '30px', fontSize: '20px' }}>
                                    Para poder votar una propuesta es obligatorio tener domicilio en Trenque Lauquen.<br />
                                    Si estás incluido en el padrón electoral del año 2023 podés votar online a través de esta plataforma.
                                    Para poder votar debes ingresar tu DNI, número de trámite, año de nacimiento y un correo electrónico dónde recibirás un código para validar el voto.<br />
                                    Se puede votar una sola vez, y un solo proyecto por persona.
                                </p>




                                {!mostrarForm &&
                                    <>
                                        <Form onSubmit={handleSubmit(onSubmit)}>
                                            <Card className="" style={{ maxWidth: '900px', marginTop: '30px' }}>
                                                <Card.Header className="text-white" style={{ backgroundColor: '#143c2c' }}>
                                                    <i className="bi bi-lock me-2"></i> Registrarse para votar
                                                </Card.Header>
                                                <Card.Body>
                                                    <ListGroup variant="flush">
                                                        <ListGroup.Item>
                                                            <div className="row g-3">
                                                                <div className="col-md-6">
                                                                    <Form.Group controlId="emailInput">
                                                                        <Form.Label>Correo electrónico</Form.Label>
                                                                        <Form.Control
                                                                            type="email"
                                                                            placeholder="Correo electrónico..."
                                                                            {...register("mail_votante", {
                                                                                required: "El correo electrónico es obligatorio",
                                                                                pattern: {
                                                                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                                                    message: "El formato del correo electrónico es incorrecto"
                                                                                }
                                                                            })}
                                                                            onChange={limpiarerrores}
                                                                            autoComplete="off"
                                                                        />
                                                                        <Form.Text className="text-muted">
                                                                            Recibirás un código en tu mail que te permitirá validar tu voto. <br />
                                                                        </Form.Text>
                                                                        {errors.mail_votante && (
                                                                            <Alert variant="danger" className="mt-2">
                                                                                {errors.mail_votante.message}
                                                                            </Alert>
                                                                        )}
                                                                    </Form.Group>
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <Form.Group controlId="nameInput">
                                                                        <Form.Label>Nombre y apellido</Form.Label>
                                                                        <Form.Control
                                                                            type="text"
                                                                            placeholder="Nombre y apellido..."
                                                                            {...register("nombre_apellido_votante", {
                                                                                required: "El nombre y apellido son obligatorios"
                                                                            })}
                                                                            onChange={limpiarerrores}
                                                                            autoComplete="off"
                                                                        />
                                                                        {errors.nombre_apellido_votante && (
                                                                            <Alert variant="danger" className="mt-2">
                                                                                {errors.nombre_apellido_votante.message}
                                                                            </Alert>
                                                                        )}
                                                                    </Form.Group>
                                                                </div>
                                                            </div>
                                                        </ListGroup.Item>

                                                        <ListGroup.Item>
                                                            <div className="row g-3">
                                                                <div className="col-md-4">
                                                                    <Form.Group controlId="dniInput">
                                                                        <Form.Label>Nro de DNI</Form.Label>
                                                                        <Form.Control
                                                                            type="text"
                                                                            placeholder="DNI..."
                                                                            {...register("dni", {
                                                                                required: "El DNI es obligatorio"
                                                                            })}
                                                                            onChange={limpiarerrores}
                                                                            autoComplete="off"
                                                                        />
                                                                        {errors.dni && (
                                                                            <Alert variant="danger" className="mt-2">
                                                                                {errors.dni.message}
                                                                            </Alert>
                                                                        )}
                                                                    </Form.Group>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <Form.Group controlId="tramiteInput">
                                                                        <Form.Label>
                                                                            Nro de trámite del DNI
                                                                            <Button
                                                                                variant="link"
                                                                                className="p-0 ms-2"
                                                                                onClick={() => setShowHelpModal(true)}
                                                                                style={{ verticalAlign: 'baseline' }}
                                                                            >
                                                                                <i className="bi bi-question-circle text-success"></i>
                                                                            </Button>
                                                                        </Form.Label>
                                                                        <Form.Control
                                                                            type="text"
                                                                            placeholder="Número de trámite del DNI..."
                                                                            {...register("nro_tramite", {
                                                                                required: "El número de trámite es obligatorio",
                                                                                minLength: { value: 11, message: "El número de trámite debe tener 11 números" },
                                                                                maxLength: { value: 11, message: "El número de trámite debe tener 11 números" },
                                                                                pattern: { value: /^[0-9]+$/i, message: "Ingresar sólo números, sin espacios ni puntos" }
                                                                            })}
                                                                            onChange={limpiarerrores}
                                                                            autoComplete="off"
                                                                        />
                                                                        {errors.nro_tramite && (
                                                                            <Alert variant="danger" className="mt-2">
                                                                                {errors.nro_tramite.message}
                                                                            </Alert>
                                                                        )}
                                                                    </Form.Group>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <Form.Group controlId="birthYearInput">
                                                                        <Form.Label>Año de nacimiento</Form.Label>
                                                                        <Form.Control
                                                                            type="text"
                                                                            placeholder="aaaa"
                                                                            {...register("anio_nac", {
                                                                                required: "El año es obligatorio",
                                                                                minLength: { value: 4, message: "El año de nacimiento debe tener 4 dígitos" },
                                                                                maxLength: { value: 4, message: "El año de nacimiento debe tener 4 dígitos" },
                                                                                pattern: { value: /^[0-9]+$/i, message: "Ingresar sólo números, sin espacios ni puntos" }
                                                                            })}
                                                                            onChange={limpiarerrores}
                                                                            autoComplete="off"
                                                                        />
                                                                        <Form.Text className="text-muted">
                                                                            Ingrese 4 dígitos para el año de nacimiento
                                                                        </Form.Text>
                                                                        {errors.anio_nac && (
                                                                            <Alert variant="danger" className="mt-2">
                                                                                {errors.anio_nac.message}
                                                                            </Alert>
                                                                        )}
                                                                    </Form.Group>
                                                                </div>
                                                            </div>
                                                        </ListGroup.Item>

                                                        <ListGroup.Item>
                                                            {dniPadron.existe && (
                                                                <Alert variant="danger" className="mt-3">
                                                                    {dniPadron.mensaje}
                                                                </Alert>
                                                            )}

                                                            {mensajeError.existe && (
                                                                <Alert variant="danger" className="mt-3">
                                                                    {mensajeError.mensaje}
                                                                </Alert>
                                                            )}

                                                            <Button type="submit" variant="success" className="mt-3" disabled>
                                                                Validar datos en el padrón
                                                                {consultandoAPI && (
                                                                    <Spinner animation="border" size="sm" className="ms-2" />
                                                                )}
                                                            </Button>
                                                        </ListGroup.Item>
                                                    </ListGroup>
                                                </Card.Body>
                                            </Card>
                                        </Form>

                                        {mostrarConfirmacion && (
                                            <Alert variant="success" className="mt-3">
                                                <strong>Código de confirmación</strong>
                                                <Form.Group controlId="confirmationCode" className="mt-2">
                                                    <Form.Label>
                                                        Enviamos un código a tu correo electrónico. <br />
                                                        <strong>Sino recibís el código revisá tu bandeja de spam o correo no desado.</strong> <br />
                                                        Ingresá el código de confirmación que recibiste para poder iniciar sesión y votar.<br />
                                                        Al validar el código podés seleccionar el proyecto que querés votar.
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        onChange={capturarValorCodigo}
                                                        placeholder="Código..."
                                                        autoComplete="off"
                                                    />
                                                </Form.Group>
                                                <div className="mt-3">
                                                    <Button variant="success" onClick={comprobarCodigoVotante} className="me-2">
                                                        Confirmar código
                                                    </Button>

                                                    <Button
                                                        variant="danger"
                                                        onClick={handleContactClick}
                                                    >
                                                        {systemOptions.whatsapp ? (
                                                            <>
                                                                <i className="bi bi-whatsapp me-2"></i>
                                                                Consultar código por WhatsApp
                                                            </>
                                                        ) : (
                                                            'NO recibo mi código'
                                                        )}
                                                    </Button>
                                                </div>
                                            </Alert>
                                        )}
                                        {errorCodigoConfirm.error && (
                                            <Alert variant="danger" className="mt-3">
                                                {errorCodigoConfirm.mensaje}
                                            </Alert>
                                        )}

                                    </>

                                }
                            </Col>
                        </Row>

                    </Container>

                    <Modal
                        show={showHelpModal}
                        onHide={() => setShowHelpModal(false)}
                        size="lg"
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>¿Dónde encuentro el número de trámite en el DNI?</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="text-center position-relative" style={{ minHeight: '200px' }}>
                                {!imageLoaded && (
                                    <div className="position-absolute top-50 start-50 translate-middle">
                                        <Spinner animation="border" variant="success" />
                                    </div>
                                )}
                                <img
                                    src="https://www.trenquelauquen.gov.ar/wordpress/wp-content/uploads/numero_tramite_dni-1.jpeg"
                                    alt="Ubicación del número de trámite en el DNI"
                                    style={{
                                        maxWidth: '100%',
                                        height: 'auto',
                                        display: imageLoaded ? 'block' : 'none'
                                    }}
                                />
                            </div>
                            <p className="mt-3 text-center">
                                El número de trámite se encuentra en el frente de tu DNI, como se muestra en la imagen.
                            </p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={() => setShowHelpModal(false)}>
                                Cerrar
                            </Button>
                        </Modal.Footer>
                    </Modal>

                    {!systemOptions.whatsapp && (
                        <ContactFormModal
                            show={showContactModal}
                            onHide={() => setShowContactModal(false)}
                            mailDestino={systemOptions.mailAyuda}
                        />
                    )}

                    {/* Precargar la imagen de manera oculta */}
                    <div style={{ display: 'none' }}>
                        <img
                            src="https://www.trenquelauquen.gov.ar/wordpress/wp-content/uploads/numero_tramite_dni-1.jpeg"
                            alt="preload"
                        />
                    </div>

                </>
            }
            {userGlobal.login === true &&
                <Navigate to="/propuestas" />
            }
        </>
    )
}

export default PanelVotante